import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CodeToHtmlPipe, SectionHeaderComponent } from '@app/widgets';

@Component({
  selector: 'app-live-updates-integration-section',
  imports: [AsyncPipe, CodeToHtmlPipe, SectionHeaderComponent],
  templateUrl: './live-updates-integration-section.component.html',
  styleUrl: './live-updates-integration-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LiveUpdatesIntegrationSectionComponent {
  public readonly code = `import { LiveUpdate } from "@capawesome/capacitor-live-update";

const sync = async () => {
  // Automatically download the latest update
  const { nextBundleId } = await LiveUpdate.sync();
  if (nextBundleId) {
    // Reload the app to apply the update
    await LiveUpdate.reload();
  }
};`;
}
